module.exports = __webpack_public_path__ + "img/certificate_right.20cfde7e.jpg";